import request from "@/api/request";
// import axios from "axios";

//验证token状态
export function CheckToken(AccessToken) {
  return request({
    method: "get",
    url: `/mini/user/check`,
    params: { "access-token": AccessToken },
  });
}
// 充值卡片数据
export function RechargeCardList() {
  return request({
    method: "get",
    url: `/background/recharge/list`,
  });
}
// 无活动创建充值卡片
export function NoActivityCreatedRechargeCard(money, is_activity) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: { money, is_activity },
  });
}
// 有活动创建充值卡片只送券
export function RechargeCardCoupon(
  money,
  is_activity,
  is_present_ticket,
  is_present_money,
  present_ticket_id,
  ticket_quantity,
) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: {
      money,
      is_activity,
      is_present_ticket,
      is_present_money,
      present_ticket_id,
      ticket_quantity,
    },
  });
}
// 有活动创建充值卡片金额优惠
export function RechargeCardAmountDiscount(
  money,
  is_activity,
  is_present_ticket,
  is_present_money,
  present_money,
) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: {
      money,
      is_activity,
      is_present_ticket,
      is_present_money,
      present_money,
    },
  });
}
// 有活动创建充值卡片金额+赠券优惠
export function RechargeCardADC(
  money,
  is_activity,
  is_present_ticket,
  is_present_money,
  present_money,
  present_ticket_id,
  ticket_quantity,
) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: {
      money,
      is_activity,
      is_present_ticket,
      is_present_money,
      present_money,
      present_ticket_id,
      ticket_quantity,
    },
  });
}
// 无活动更新充值卡片
export function NoActivityUpdateRechargeCard(id, money, is_activity) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: { id, money, is_activity },
  });
}
// 有活动更新充值卡片
export function ActivityUpdateRechargeCard(
  id,
  money,
  is_activity,
  is_present_ticket,
  is_present_money,
  present_ticket_id,
  present_money,
  ticket_quantity,
) {
  return request({
    method: "post",
    url: `/background/recharge/upsert`,
    data: {
      id,
      money,
      is_activity,
      is_present_ticket,
      is_present_money,
      present_ticket_id,
      present_money,
      ticket_quantity,
    },
  });
}
// 删除充值卡片
export function DeleteRechargeCard(id) {
  return request({
    method: "post",
    url: `/background/recharge/delete`,
    data: { id },
  });
}

// 上传COS图凭证获取
export function getCosSignature() {
  return request({
    method: "get",
    url: `/mini/upload/getCosSignature`,
  });
}
// 保存图片
export function SaveImage(
  filename, //COS存储路径
  original_name, //原始文件名
  size, //文件大小(字节)(可选)
  mime_type, //文件类型(可选)
  ext, //文件扩展名(可选)
  url, //访问地址
  bucket, //(可选)
  region, //(可选)
  type, //文件类型 0：轮播图, 1：鉴定图 , 2：栏目icon , 3：其他文件
) {
  return request({
    method: "post",
    url: `/mini/upload/callback`,
    data: {
      filename,
      original_name,
      size,
      mime_type,
      ext,
      url,
      bucket,
      region,
      type,
    },
  });
}

// 查询轮播图
export function SelectSwiper() {
  return request({
    method: "get",
    url: `/background/banner/list`,
  });
}
// 设置轮播图
export function SetSwiper(
  file_id, //COS存储路径
  level, //原始文件名
) {
  return request({
    method: "post",
    url: `/background/banner/create`,
    data: { file_id, level },
  });
}
// 删除轮播图
export function DelSwiper(id) {
  return request({
    method: "post",
    url: `/background/banner/delete`,
    data: { id },
  });
}
// 修改轮播图排序
export function ChangeSwiperLevel(id, level) {
  return request({
    method: "post",
    url: `/background/banner/sort`,
    data: { id, level },
  });
}

//筛选获取门店订单信息
export function StoreOrderList_Search(
  page,
  limit,
  search,
  appraiser_id,
  category_id,
  status,
  order_type,
  brand_id,
  no_item,
) {
  return request({
    method: "get",
    url: `/background/post/list`,
    params: {
      page,
      limit,
      search,
      appraiser_id,
      category_id,
      status,
      order_type,
      brand_id,
      no_item,
    },
  });
}

//切换门店订单隐藏状态
export function StoreOrderList_Hide(id) {
  return request({
    method: "post",
    url: `/background/post/delete`,
    data: {
      id,
    },
  });
}

//删除门店订单
export function StoreOrderList_RealDelete(id) {
  return request({
    method: "post",
    url: `/background/post/RealDelete`,
    data: {
      id,
    },
  });
}
//更新门店订单鉴定结果与类目品牌
export function StoreOrderList_Update(
  id,
  category_id,
  brand_id,
  is_true,
  no_item,
  authenticate_result,
  force_return,
  status,
) {
  return request({
    method: "post",
    url: `/background/post/update`,
    data: {
      id,
      category_id,
      brand_id,
      is_true,
      no_item,
      authenticate_result,
      force_return,
      status,
    },
  });
}
//接单
export function StoreOrderAcceptOrders(id, status) {
  return request({
    method: "post",
    url: `/background/post/update`,
    data: {
      id,
      status,
    },
  });
}
//退单
export function StoreOrderForceReturn(id, force_return) {
  return request({
    method: "post",
    url: `/background/post/update`,
    data: {
      id,
      force_return,
    },
  });
}
//更新门店订单鉴定结果与类目品牌
export function categoryVps(category_id) {
  return request({
    method: "get",
    url: `/background/categoryVps/list`,
    data: {
      category_id,
    },
  });
}
// 更新类目包赔价格、费用、鉴定点
export function UpdateCategoryVps(id, category_id, fee, points, commit) {
  return request({
    method: "post",
    url: `/background/categoryVps/upsert`,
    data: { id, category_id, fee, points, commit },
  });
}
// 删除类目包赔价格、费用、鉴定点
export function DeleteCategoryVps(id) {
  return request({
    method: "post",
    url: `/background/categoryVps/delete`,
    data: { id },
  });
}
// 获取用户信息
export function GetUserInfo(page, limit, search, type) {
  return request({
    method: "get",
    url: `/background/user/usersList`,
    params: { page, limit, search, type },
  });
}
// 更改用户权限
export function IncreasePermissions(user_id, category_id, is_cancel) {
  return request({
    method: "post",
    url: `/background/user/operateAppraiser`,
    data: { user_id, category_id, is_cancel },
  });
}

// 更改用户权限
export function SetAdministrator(user_id, is_cancel) {
  return request({
    method: "post",
    url: `/background/user/setAdministrator`,
    data: { user_id, is_cancel },
  });
}
// 查询类目
export function GetCategory() {
  return request({
    method: "get",
    url: `/background/category/list`,
  });
}
// 更改类目
export function UpdateCategory(file_id, name, fee, points, level, id, status) {
  return request({
    method: "post",
    url: `/background/category/upsert`,
    data: { file_id, name, fee, points, level, id, status },
  });
}
// 新增类目
export function AddCategory(file_id, name, fee, points, level, status) {
  return request({
    method: "post",
    url: `/background/category/upsert`,
    data: { file_id, name, fee, points, level, status },
  });
}
// 删除类目
export function DeleteCategory(category_id) {
  return request({
    method: "post",
    url: `/background/category/delete`,
    data: { category_id },
  });
}
// 删除品牌
export function DeleteBrand(brand_id) {
  return request({
    method: "post",
    url: `/background/category/delete`,
    data: { brand_id },
  });
}
// 导入品牌
export function UploadBrand(file) {
  const formData = new FormData();
  formData.append("file", file);
  return request({
    method: "post",
    url: `/background/category/export`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 用户钱包关系
export function ShareWalletUserList(page, limit, search) {
  return request({
    method: "get",
    url: `/background/user/selShareWalletUserList`,
    params: { page, limit, search },
  });
}
// 给用户充值余额
export function rechargeWallet(user_id, amount) {
  return request({
    method: "post",
    url: `/background/user/rechargeWallet`,
    params: { user_id, amount },
  });
}

// 鉴定师账目
export function AppraiserAccounts(
  page,
  limit,
  start_time,
  end_time,
  date_range,
) {
  return request({
    method: "get",
    url: `/background/user/appraiserPerformance`,
    params: { page, limit, start_time, end_time, date_range },
  });
}
// 鉴定师订单详情
export function AppraiserDetail(
  page,
  limit,
  start_time,
  end_time,
  date_range,
  appraiser_id,
) {
  return request({
    method: "get",
    url: `/background/user/appraiserDetail`,
    params: { page, limit, start_time, end_time, date_range, appraiser_id },
  });
}

//登录
export function Login(telnumber, password) {
  return request({
    method: "post",
    url: `/background/user/login`,
    data: { name: telnumber, password },
  });
}
//修改密码
export function ChangePwd(telnumber, password) {
  return request({
    method: "post",
    url: `/background/user/updatePassword`,
    data: { old_password: telnumber, new_password: password },
  });
}
